import { FC } from 'react';

export const PartnerReviews: FC = () => {
  return <section>Reviews</section>;
};
